
<template>
  <div class="container">
    <Header />
    <header-searchtwo></header-searchtwo>

    <div class="bodyContainer">
      <div class="columnContainer">
        <div class="rowContainer">
          <div class="title">企业名称：</div>
          <el-input class="inputContainer" placeholder="请输入" v-model="formDate.company_name"></el-input>
        </div>

        <div class="rowContainer">
          <div class="title">联系人姓名：</div>
          <el-input class="inputContainer" placeholder="请输入" v-model="formDate.contact_man"></el-input>
        </div>

        <div class="rowContainer">
          <div class="title">邮箱：</div>
          <el-input class="inputContainer" placeholder="请输入" v-model="formDate.email"></el-input>
        </div>

        <div class="rowContainer">
          <el-button type="danger" @click="changeUserInfo()" class="el-button">确定</el-button>

          <el-button @click="$router.go(-1)" class="el-button">取消</el-button>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from "../header";
import footer from "../footer";
import headersearchtwo from "../headersearchtwo";

// import store from "@/vuex/store";
import { mapMutations, mapActions } from "vuex";

export default {
  name: "changeinfo",
  components: {
    Header,
    "v-footer": footer,
    "header-searchtwo": headersearchtwo
  },
  data() {
    return {
      formDate: {
        company_name: "",
        contact_man: "",
        email: ""
      }
    };
  },
  methods: {
    changeUserInfo() {
      if (
        this.formDate.company_name < 0 ||
        this.formDate.contact_man < 0 ||
        this.formDate.email < 0
      ) {
        this.$message({
          message: "请先把信息填写完整",
          type: "warning"
        });
        return;
      }
      this.$http.changeUserInfo(this.formDate).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            message: "修改信息成功",
            type: "success"
          });
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}

.bodyContainer {
  position: relative;
  width: 1200px;
  height: 700px;
  background-color: #fff;
  margin: 24px auto;
  padding: 64px 0 0 0;
}

.columnContainer {
  width: 800px;
  /* border: solid 1px red;*/
  margin: auto;
  /*flex-direction: column;*/
}

.rowContainer {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.title {
  width: 100px;
  height: 40px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: right;
  line-height: 40px;
  margin-right: 20px;
}

.inputContainer {
  width: 320px;
  height: 40px;
}
.el-button {
  width: 80px;
  height: 40px;
}
</style>
